import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core"
import React from "react"

import { globalStyles } from "../../../../Componentes/CssGlobal"
import { button } from "../../../../Componentes/Inputs/TextFild"
import useStyles from "./styles"
import CloseIcon from "@material-ui/icons/Close"

import usuarioFree from "../../../../Assets/img/usuario-free.png"
import { useHistory } from "react-router-dom"
import { SimpleImg } from "react-simple-img"
import { createLeedPro } from "../../../../utils"

export default function PlanosAlertaModal({ isOpen, handleClose, bannerId }) {
  const classesGlobal = globalStyles()
  const classes = useStyles()
  const history = useHistory()

  const hasLeedPro = () => {
    createLeedPro(bannerId)
  }

  return (
    <div className="page-container">
      <div className="page-align">
        <div className="infinite-scroll">
          <div onClick={hasLeedPro} aria-hidden="true">
            <Dialog
              open={isOpen}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
              className={classes.PlanosAlertaModal}
            >
              <DialogTitle id="responsive-dialog-title">
                <div className={classes.PlanosAlertaModalHeader}>
                  <h2>Oops...</h2>
                  <button type="button" onClick={handleClose}>
                    <CloseIcon
                      style={{
                        fontSize: "35px",
                        color: "#EA3458",
                        cursor: "pointer",
                        minWidth: "30px"
                      }}
                    />
                  </button>
                </div>
              </DialogTitle>
              <DialogContent>
                <DialogContentText className={classes.PlanosAlertaModalBody}>
                  <SimpleImg
                    width="auto"
                    height="auto"
                    placeholder={false}
                    src={usuarioFree}
                    alt="usuario-free"
                  />
                  <p>Parece que você ainda é um usuário free, não é mesmo?</p>
                  <p>
                    Que tal conhecer o nosso plano <span>PRO </span> e descobrir
                    todas as vantagens que você pode ter? 😉
                  </p>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {button({
                  name: `Quero conhecer o plano PRO!`,
                  funcao: () => history.push("/planos")
                })}
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  )
}
